import { logAmplitudeEventAllowCustomers } from 'amplitude/amplitude'
import {
  Alert,
  BaseThemeType,
  CloseIcon,
  ComponentVersions_3_0,
  ComponentVersionsInherit,
  styled,
  Typography,
} from 'opensolar-ui'
import { useEffect, useState } from 'react'
import { formatDateStringBaseOnLocale } from 'util/misc'
import { useGetMarketplaceApplicationResults } from '../utils'

type PropTypes = {
  projectId: number
  orgId: number
}

const TitleRow = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
}))

const CloseIconWrapper = styled('div')(() => ({
  cursor: 'pointer',
}))

const TitleText = styled(Typography)(({ theme }: { theme: BaseThemeType }) => ({
  color: theme.palette.blue[1000],
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '24px',
}))

const DescriptionText = styled(Typography)(({ theme }: { theme: BaseThemeType }) => ({
  color: theme.palette.blue[1000],
}))

const FinanceMarketplaceApplicationStatus = (props: PropTypes) => {
  const [hide, setHide] = useState(false)
  const { projectId, orgId } = props

  const { applicationResults, applicationsAreLoading } = useGetMarketplaceApplicationResults(orgId, projectId)

  useEffect(() => {
    if (applicationResults?.length) {
      logAmplitudeEventAllowCustomers('marketplace_previous_applications_shown', {
        org_id: orgId,
        project_id: projectId,
        application_count: applicationResults?.length,
      })
    }
  }, [applicationResults?.length])

  if (!applicationResults?.length || hide) {
    return null
  }

  const nonDeclinedApplications = applicationResults?.filter(
    (app) => app.status !== 'declined' && app.status !== 'created'
  )

  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Alert severity="info">
        <>
          <TitleRow>
            <TitleText textVariant="body1">Application Submitted</TitleText>
            <CloseIconWrapper onClick={() => setHide(true)}>
              <CloseIcon />
            </CloseIconWrapper>
          </TitleRow>
          <DescriptionText textVariant="body1">
            You have already submitted the following applications for this system design. If the system you are
            purchasing has changed or you'd like to update your application you can re-apply at any point using the
            "Apply now" buttons below
          </DescriptionText>
          <ul>
            {nonDeclinedApplications?.map((app) => (
              <li key={app.id}>
                <DescriptionText textVariant="body1">
                  {formatDateStringBaseOnLocale(app.application_date)} - you submitted an application to{' '}
                  {app.integration_display_name} and the current status of that application is <u>{app.status}</u>
                </DescriptionText>
              </li>
            ))}
          </ul>
        </>
      </Alert>
    </ComponentVersionsInherit>
  )
}

export default FinanceMarketplaceApplicationStatus
